import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/remote-config';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

export const FireBaseCollections = {
  Merchants: {
    collectionName: 'Merchants',
    fields: {
      seenWhatsNewWeb: 'seenWhatsNewWeb',
      permissionUpdatedWeb: 'PermissionUpdatedWeb',
      permissionLastUpdatedAt: 'PermissionLastUpdatedAt',
      userFlagsUpdated: 'UserFlagsUpdated',
      seenNewSignatureModalWeb: 'seenNewSignatureModalWeb',
      seenDispatchWhatsNewWeb: 'seenDispatchWhatsNewWeb',
      /** Merchant dismissed the invoice discount calculation What's New modal (web). */
      seenInvoiceDiscountCalculationWhatsNewWeb: 'seenInvoiceDiscountCalculationWhatsNewWeb',
      /** Merchant dismissed the discount calculation coachmark on the Invoice Settings -> Discount section (web). */
      seenInvoiceDiscountCalculationCoachmarkSettingsWeb: 'seenInvoiceDiscountCalculationCoachmarkSettingsWeb',
      /** Merchant dismissed the discount calculation coachmark on the Create Invoice -> Add Discount row (web). */
      seenInvoiceDiscountCalculationCoachmarkCreateInvoiceWeb:
        'seenInvoiceDiscountCalculationCoachmarkCreateInvoiceWeb',
      /** Merchant dismissed the apply-after-tax coachmark inside the Add/Edit Discount modal (web). */
      seenInvoiceDiscountCalculationCoachmarkAddDiscountModalWeb:
        'seenInvoiceDiscountCalculationCoachmarkAddDiscountModalWeb'
    }
  },
  Notifications: {
    collectionName: 'Notifications'
  },
  Teams: {
    collectionName: 'Teams',
    fields: {
      estimateStatusUpdated: 'subscription-status-updated',
      permissionUpdatedAtWeb: 'PermissionUpdatedWeb',
      customizationUpdatedWeb: 'CustomizationUpdatedWeb',
      customizationLastUpdatedAt: 'CustomizationLastUpdatedAt',
      collectWABankDetails: 'collect-wallet-bank-account-details',
      walletEligibleBankAccountSubmitted: 'wallet-eligible-bank-account-submitted',
      legalReacceptanceWalletBankScreenShownCount: 'LegalReacceptanceWalletBankScreenShownCount'
    }
  }
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const remoteConfig = firebaseApp.remoteConfig();
export { db, remoteConfig };
